import PropTypes from "prop-types";

function RadioInput({ label, type, name, onChange, error, options }) {
  const mapOptions = options.map((option) => {
    return (
      <div key={option} className="flex items-center mr-4 radio-option border rounded focus:outline-none focus:border-none p-3 bg-white">
        <input name={name} value={option} type={type} onChange={onChange} className="w-6 h-4"/>
        <label className="capitalize ml-1">{JSON.stringify(option)}</label>
      </div>
    );
  });
  return (
    <div className="flex flex-col mb-4">
      {label && <label className="label mb-2 text-gray-500">{label}</label>}
      <div className="flex">{mapOptions}</div>
      {error && error.name === name && (
        <small className="error">{error.message}</small>
      )}
    </div>
  );
}

RadioInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.object,
  options: PropTypes.array,
};

export default RadioInput;
